import script from "./render-content-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./render-content-page.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__